import { render, staticRenderFns } from "./NawDrawerListItem.vue?vue&type=template&id=2059aa4a&scoped=true&"
import script from "./NawDrawerListItem.vue?vue&type=script&lang=js&"
export * from "./NawDrawerListItem.vue?vue&type=script&lang=js&"
import style0 from "./NawDrawerListItem.vue?vue&type=style&index=0&id=2059aa4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059aa4a",
  null
  
)

export default component.exports